// removed by extract-text-webpack-plugin
module.exports = {"root":"_3QlfW","title":"_943_L","imgWrapper":"_3_3wd","description":"qQxWU"};